
import { FormattedMessage, injectIntl, defineMessages, FormattedNumber } from 'react-intl'
import React from "react";

class InvoiceHelper {

    static getStatusName(intl, status) {
        switch (status) {
            case 'draft':
                return intl.formatMessage({
                    id: "invoice.status.draft_label",
                    defaultMessage: "Draft",
                })
            case 'sent':
                return intl.formatMessage({
                    id: "invoice.status.waiting_for_payment_label",
                    defaultMessage: "Waiting for payment",
                })
            case 'partially-paid':
                return intl.formatMessage({
                    id: "invoice.status.partially_paid_label",
                    defaultMessage: "Partially paid",
                })
            case 'fully-paid':
                return intl.formatMessage({
                    id: "invoice.status.fully_paid_label",
                    defaultMessage: "Fully paid",
                })
            case 'voided':
                return intl.formatMessage({
                    id: "invoice.status.voided_label",
                    defaultMessage: "Voided",
                })
            case 'active':
                return intl.formatMessage({
                    id: "invoice.status.active_label",
                    defaultMessage: "Active",
                })
            case 'inactive':
                return intl.formatMessage({
                    id: "invoice.status.inactive_label",
                    defaultMessage: "Inactive",
                })
            case 'finished':
                return intl.formatMessage({
                    id: "invoice.status.finished_label",
                    defaultMessage: "Finished",
                })
        }
    }


    static GetOverCreditLimitMessagePermissionProceed(currency, customerOwingBalance, newDebtAmount, creditLimit, havePermission) {
        const newOwingBalance = String(parseFloat(customerOwingBalance) + parseFloat(newDebtAmount))
        const creditLimitPrompt = <FormattedMessage
            id="invoice.edit.over_credit_limit_warning_prompt"
            defaultMessage="Including this invoice's total amount, this customer's owing balance would become {totalAmount} and it would exceed their current credit limit of {creditLimit}."
            values={{
                totalAmount: <strong className="text-danger">
                    <FormattedNumber
                        style="currency"
                        currency={currency}
                        value={newOwingBalance}
                    />
                </strong>,
                creditLimit: <strong className="text-danger">
                    <FormattedNumber
                        style="currency"
                        currency={currency}
                        value={creditLimit}
                    />
                </strong>
            }}
        />
        if (havePermission) {
            return <FormattedMessage
                id="invoice.edit.allow"
                defaultMessage="{prompt} Are you sure you want to proceed?"
                values={{
                    prompt: creditLimitPrompt
                }} />
        }
        else {
            return <FormattedMessage
                id="invoice.edit.deny"
                defaultMessage="{prompt} You can't create this invoice. Contact an administrator to force the creation."
                values={{
                    prompt: creditLimitPrompt
                }} />
        }
    }

}

export default injectIntl(InvoiceHelper)


// WEBPACK FOOTER //
// ./src/invoice/invoicehelper.jsx